/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

/**
 * Form for creating a new tunneled MCP server source
 */
export type CreateTunneledMcpServerForm = {
  /**
   * Human-readable display name for the tunneled MCP server
   */
  name: string;
  /**
   * RFC 9728 protected resource identifier of the tunneled server, used for credential routing and as the signed caller assertion audience; never dialed by Speakeasy. The exact identifier is preserved, including trailing slashes. When unset, caller assertions use tunneled-mcp-server:<ID>. Omit unless the identifier is already known; it is usually recorded later, once the tunnel is up.
   */
  resourceIdentifier?: string | undefined;
};

/** @internal */
export type CreateTunneledMcpServerForm$Outbound = {
  name: string;
  resource_identifier?: string | undefined;
};

/** @internal */
export const CreateTunneledMcpServerForm$outboundSchema: z.ZodMiniType<
  CreateTunneledMcpServerForm$Outbound,
  CreateTunneledMcpServerForm
> = z.pipe(
  z.object({
    name: z.string(),
    resourceIdentifier: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      resourceIdentifier: "resource_identifier",
    });
  }),
);

export function createTunneledMcpServerFormToJSON(
  createTunneledMcpServerForm: CreateTunneledMcpServerForm,
): string {
  return JSON.stringify(
    CreateTunneledMcpServerForm$outboundSchema.parse(
      createTunneledMcpServerForm,
    ),
  );
}
